// "just now", "5 minutes ago", "yesterday", then a date
export const timeAgo = (iso) => {
  if (!iso) return '';
  const then = new Date(iso);
  const seconds = Math.round((Date.now() - then.getTime()) / 1000);
  if (Number.isNaN(seconds)) return '';
  if (seconds < 45) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  const days = Math.round(hours / 24);
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days} days ago`;
  return then.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
};

// Full local date and time, for tooltips
export const formatDateTime = (iso) => (iso ? new Date(iso).toLocaleString() : '');

// "today", "tomorrow", "in 12 days", then a date - the forward-looking sibling of timeAgo
export const timeUntil = (iso, now = new Date()) => {
  if (!iso) return '';
  const then = new Date(iso);
  const seconds = Math.round((then.getTime() - now.getTime()) / 1000);
  if (Number.isNaN(seconds)) return '';
  if (seconds <= 0) return 'today';
  const days = Math.floor(seconds / 86400);
  if (days < 1) return 'today';
  if (days === 1) return 'tomorrow';
  if (days < 45) return `in ${days} days`;
  return `on ${then.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })}`;
};
